import {useId} from 'react'
import {SoftNavOnlyLink as Link} from '@github-ui/react-router'
import type {SidebarLink} from '@github-ui/saved-views'
import {useAnalytics} from '@github-ui/use-analytics'
import {PlusIcon} from '@primer/octicons-react'
import {IconButton, NavList, Truncate} from '@primer/react'
import {SidebarLinkIcon} from '../sidebar-link-icon/SidebarLinkIcon'
import {getHandlerNavItemClick} from '../../utils/sidebar-link'

import styles from './SidebarSavedViews.module.css'

interface SidebarSavedViewsProps {
  dashboardType: string
  savedViews: SidebarLink[]
  onSelectLink: (linkItem: SidebarLink) => void
  selectedLink: string
  onCreateView: () => void
  generateLinkPath: (path: string | undefined, query?: string) => string
}

export function SidebarSavedViews({
  dashboardType,
  savedViews,
  selectedLink,
  onSelectLink,
  onCreateView,
  generateLinkPath,
}: SidebarSavedViewsProps) {
  const {sendAnalyticsEvent} = useAnalytics()
  const createViewButtonId = useId()
  return (
    <div>
      <hr className={styles.divider} />
      <div className={styles.container}>
        <div className={styles.headerRow} id={createViewButtonId}>
          <span className={styles.headerRowText}>Views</span>
          <IconButton
            icon={PlusIcon}
            size="small"
            variant="invisible"
            onClick={onCreateView}
            aria-label="Create view"
          />
        </div>
        {savedViews.length === 0 ? (
          <p className={styles.emptyState}>No saved views</p>
        ) : (
          <NavList aria-labelledby={createViewButtonId} className={styles.savedViewsList}>
            {savedViews.map(linkItem => (
              <NavList.Item
                as={Link}
                aria-current={selectedLink === linkItem.id && 'page'}
                key={linkItem.id}
                to={generateLinkPath(linkItem.id, linkItem.query)}
                onClick={getHandlerNavItemClick({dashboardType, onSelectLink, sendAnalyticsEvent, linkItem})}
              >
                <NavList.LeadingVisual>
                  <SidebarLinkIcon name={linkItem.icon} color={linkItem.color} />
                </NavList.LeadingVisual>
                <Truncate title={linkItem.name} maxWidth="100%">
                  {linkItem.name}
                </Truncate>
              </NavList.Item>
            ))}
          </NavList>
        )}
      </div>
    </div>
  )
}
